
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdSave, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import './AddEmployee.css';
import Swal from 'sweetalert2';
import { GET_ALL_ROLE_API, REGISTER_API } from '../config/API';
import { authFetch } from '../components/utils/authFetch';
import { showErrorToast } from '../utils/toastUtils';

const AddEmployee = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        contactNumber: '',
        email: '',
        userName: '',
        password: '',
        confirmPassword: '',
        gender: '',
        roleId: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [roles, setRoles] = useState([]);


    const getAllRoles = async () => {
        try {
            const response = await fetch(GET_ALL_ROLE_API);
            const result = await response.json();

            if (result.status) {
                const filteredRoles = result.data.filter(
                    role => role.roleName !== "SUPER_ADMIN"
                );
                setRoles(filteredRoles);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllRoles();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const confirm = await Swal.fire({
            title: 'Save Associate?',
            text: 'Do you want to save this associate?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#4f46e5',
            buttonsStyling: false,
            customClass: {
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn',
            },
        });

        if (!confirm.isConfirmed) return;

        try {
            const token = localStorage.getItem('accessToken');

            const response = await authFetch
                (
                    REGISTER_API,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify(formData),
                    }
                );

            const result = await response.json();

            if (!response.ok) {
                showErrorToast(result.message || result.error || 'Failed to add associate');
                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Associate added successfully',
                timer: 2000,
                showConfirmButton: false
            });
            navigate('/employees');

        } catch (error) {
            console.error('Error adding associate:', error);
            showErrorToast(error.message || 'An error occurred');
        }
    };


    return (
        <div className="add-employee-page">
            <div className="page-header">
                <button onClick={() => navigate('/employees')} className="back-btn">
                    <MdArrowBack />
                </button>
                <h2>Add New Associate</h2>
            </div>

            <form onSubmit={handleSubmit} className="employee-form">
                <div className="form-section">
                    <h3>Personal Details</h3>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>First Name <span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                placeholder="Enter first name"
                            />
                        </div>
                        <div className="form-group">
                            <label>Last Name <span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder="Enter last name"
                            />
                        </div>
                        <div className="form-group">
                            <label>Contact Number <span className="required-star">*</span></label>
                            <input
                                type="tel"
                                name="contactNumber"
                                value={formData.contactNumber}
                                onChange={handleChange}
                                placeholder="Enter contact number"
                            />
                        </div>
                        <div className="form-group">
                            <label>Email ID</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter email address"
                            />
                        </div>
                        <div className="form-group">
                            <label>Gender <span className="required-star">*</span></label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <h3>Account Information</h3>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Username <span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="userName"
                                value={formData.userName}
                                onChange={handleChange}
                                placeholder="Enter username"
                            />
                        </div>
                        <div className="form-group">
                            <label>Role <span className="required-star">*</span></label>
                            <select
                                name="roleId"
                                value={formData.roleId}
                                onChange={handleChange}
                            >
                                <option value="">Select Role</option>
                                {roles.map((role) => (
                                    <option key={role.id} value={role.id}>
                                        {role.roleName.replace("_", " ")}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Password <span className="required-star">*</span></label>
                            <div className="password-input-wrapper">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Enter password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="password-toggle-btn"
                                    title={showPassword ? "Hide Password" : "Show Password"}
                                >
                                    {showPassword ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
                                </button>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Confirm Password <span className="required-star">*</span></label>
                            <div className="password-input-wrapper">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    placeholder="Confirm password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    className="password-toggle-btn"
                                    title={showConfirmPassword ? "Hide Password" : "Show Password"}
                                >
                                    {showConfirmPassword ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" onClick={() => navigate('/employees')} className="cancel-btn">
                        Cancel
                    </button>
                    <button type="submit" className="save-btn">
                        <MdSave /> Save Employee
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddEmployee;
